module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "contact-section"
    }
  }, [_c('div', {
    staticClass: "row text-center desktop"
  }, [_c('h2', {
    staticClass: "heading-light"
  }, [_vm._v("GET IN TOUCH")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.contact.instagram_link
    }
  }, [_c('span', {
    staticClass: "contact-social-icon"
  }, [_c('img', {
    staticClass: "social-icon-svg",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.instagram_icon_dark,
      "type": "image/svg+xml"
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.instagram_text)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.contact.email_link
    }
  }, [_c('span', {
    staticClass: "contact-social-icon"
  }, [_c('img', {
    staticClass: "social-icon-svg",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.email_icon_dark,
      "type": "image/svg+xml"
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.email_text)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.contact.phone_link
    }
  }, [_c('span', {
    staticClass: "contact-social-icon"
  }, [_c('img', {
    staticClass: "social-icon-svg",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.phone_icon_dark,
      "type": "image/svg+xml"
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.phone_text)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center mobile"
  }, [_c('h2', {
    staticClass: "heading-light"
  }, [_vm._v("GET IN TOUCH")]), _vm._v(" "), _c('div', {
    staticClass: "contact-social-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.contact.email_link
    }
  }, [_c('img', {
    staticClass: "social-icon-svg social-icon-svg-dark",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.email_icon_dark,
      "type": "image/svg+xml"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "social-icon-svg social-icon-svg-light",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.email_icon_light,
      "type": "image/svg+xml"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "contact-social-icon contact-social-icon-insta"
  }, [_c('a', {
    attrs: {
      "href": _vm.contact.instagram_link,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "social-icon-svg social-icon-svg-dark",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.instagram_icon_dark,
      "type": "image/svg+xml"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "social-icon-svg social-icon-svg-light",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.instagram_icon_light,
      "type": "image/svg+xml"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "contact-social-icon contact-social-icon-insta"
  }, [_c('a', {
    attrs: {
      "href": _vm.contact.phone_link,
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "social-icon-svg social-icon-svg-dark",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.phone_icon_dark,
      "type": "image/svg+xml"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "social-icon-svg social-icon-svg-light",
    attrs: {
      "src": 'static/img/common/' + _vm.contact.phone_icon_light,
      "type": "image/svg+xml"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6005547a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactSection.vue
// module id = 146
// module chunks = 2